shadow$provide[1] = function(global,require,module,exports) {
module.exports=(React);
};